import { ModelBase, TnEngineExtraContext } from "pytha";
import { BaseCommand } from "./base-command";

export class MonixAddPrimitivesCommand extends BaseCommand {

    entities: ModelBase[] = [];
    extraContext: TnEngineExtraContext;
    onExecuteCallback: () => void;
    onUndoCallback: () => void;

    constructor(entities: ModelBase[], executeCallback?: () => void, undoCallback?: () => void) {
        super();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.editor = this.extraContext.getCurrentViewEditor();
        this.entities = entities;
        this.onExecuteCallback = executeCallback || (() => {});
        this.onUndoCallback = undoCallback || (() => {});
    }

    execute(): void {
        this.editor.addObjects(this.entities);
        this.editor.listeners.signals.needRender.dispatch('redraw');
        this.onExecuteCallback();
    }

    undo(): void {
        this.editor.removeObjects(this.entities);
        this.editor.listeners.signals.needRender.dispatch('redraw');
        this.onUndoCallback();
    }
}
